import { Injectable } from '@angular/core';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL, DICE_URL } from 'src/app/_common/constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  constructor(private http: HttpClient) { }

  downloadFile(blob: any, type: string, filename: string): any {
    if(!blob){
      return null;
    }
    if (window.navigator.msSaveOrOpenBlob) {
      // IE browsers
      window.navigator.msSaveOrOpenBlob(blob, `${filename}.pdf`);
    }else {
      const url = window.URL.createObjectURL(blob); // <-- work with blob directly
    
      // create hidden dom element (so it works in all browsers)
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
    
      // create file, attach to hidden element and open hidden element
      a.href = url;
      a.download = filename;
      a.click();
      document.body.removeChild(a);
      return url;
    }
  }

  downloadInvoice(_accountNumber, _invoiceNumber): Observable<HttpResponse<any>>{
    return this.http.get<any>(API_URL.DownloadInvoice+"?accountNumber="+_accountNumber+"&invoiceNumber="+_invoiceNumber, {observe: 'response', responseType: 'blob' as 'json'})
        .pipe(map(res => {
          return this.downloadFile(res.body, 'application/pdf', "Invoice_" +_invoiceNumber+"_"+ _accountNumber+".pdf");
      }));
  }

  downloadNotice(_notice, _accountNumber): Observable<HttpResponse<any>>{
    return this.http.get<any>(API_URL.DownloadNotice+"?documentId="+_notice.id, {observe: 'response', responseType: 'blob' as 'json'})
        .pipe(map(res => {
          return this.downloadFile(res.body, 'application/pdf', _notice.description + "_" +_notice.id + "_" + _accountNumber+".pdf");
      }));
  }

  downloadLossRunReport(_number, reportBy) {
    return this.http.get<any>(API_URL.DownloadLossRunReport+ "?"+ reportBy +"="+ _number, {observe: 'response', responseType: 'blob' as 'json'})
        .pipe(map(res => {
          return this.downloadFile(res.body, 'application/pdf', "LossRunReport_"+_number+".pdf");
      }));
  }
  /*** Downloading Policy Documents or Quote Letter ***/
  downloadDocuments(docType, _documentDts){    
    return this.http.post<any>(DICE_URL.DocumentDownload, _documentDts, {observe: 'response'})
    .pipe(map(response => {
      let _result: any = response.body.result;
      if(_result){
        var binaryString = window.atob(_result.documentBytes);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return this.downloadFile(new Blob([bytes],{ type: _result.documentHeader.mediaType }), _result.documentHeader.mediaType, _result.documentHeader.documentTypeName);
      }else{
        return null; 
      }
    }));
  }

  downloadBillingDocuments(_accountNumber, _documentId) {
      return this.http.get<any>(API_URL.DownloadBillingDocuments+"?accountNumber="+_accountNumber+"&documentid="+_documentId, {observe: 'response'})
      .pipe(map(response => {
        let _result: any = response.body.result;
        if(_result){
          var binaryString = window.atob(_result.documentBytes);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);
          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          return this.downloadFile(new Blob([bytes],{ type: _result.documentHeader.mediaType }), _result.documentHeader.mediaType, (_result.documentHeader.documentTypeName + "_" + _documentId + "_" + _accountNumber + "." +  _result.documentHeader.mediaType || "application_" + _documentId + "_" + _accountNumber + "." + _result.documentHeader.mediaType));
        }else{
          return null; 
        }
      }));
  }

  downloadPolicyDocument(accountId, documentId, documentName) {
    return this.http.get<any>(API_URL.PolicyDocumentDownload+"?accountNumber="+accountId+"&documentId="+documentId, {observe: 'response'})
        .pipe(map(res => {
          if(res.body.result){
            var binaryString = window.atob(res.body.result.documentBytes);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
              var ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }
            return this.downloadFile(new Blob([bytes],{ type: res.body.result.documentHeader.mediaType }), res.body.result.documentHeader.mediaType, ((res.body.result.documentHeader.description.trim())?(res.body.result.documentHeader.description+"."+res.body.result.documentHeader.mediaType):documentName+ "." + res.body.result.documentHeader.mediaType));
          }else{
            return null; 
          }
      }));
  }


}
